import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import { SearchFiltersLoader } from './hooks/SearchFiltersLoader';
import SearchFilters, { Filters } from './parts/SearchFilters';

const SectionsData = () => {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );
  const [filters, setFilters] = useState<Filters | null>(null);

  const handleFiltersChange = (filterValues: Filters) => {
    setFilters(filterValues);
    // TODO: Implementar lógica para filtrar los datos con los valores recibidos
    console.log('Filters applied:', filterValues);
  };

  const handleCreateCourse = () => {
    // TODO: Navigate to create course path
    console.log('Navigate to create course');
  };

  const handleCreateProgram = () => {
    // TODO: Navigate to create program path
    console.log('Navigate to create program');
  };

  return (
    <div className="mx-3">
      <Card className="p-4 mt-2">
        <h2 className="text-primary fs-20 fw-700 mb-4 text-uppercase">
          {t('title')}
        </h2>
        <SearchFiltersLoader fetchImmediately>
          <SearchFilters
            onFiltersChange={handleFiltersChange}
            createHandlers={{
              onCreateCourse: handleCreateCourse,
              onCreateProgram: handleCreateProgram,
            }}
          />
        </SearchFiltersLoader>

        {/* TODO: Agregar tabla o listado de planes de estudio filtrados */}
        {filters && (
          <div className="mt-4">
            <p>Filtros aplicados:</p>
            <pre>{JSON.stringify(filters, null, 2)}</pre>
          </div>
        )}
      </Card>
    </div>
  );
};

const Sections = () => {
  return <SectionsData />;
};

export default Sections;
